import React from 'react';

import {
  BaseWidget,
  LabelledText
} from 'modules';

import { Grid } from '@mui/material';
import * as dataService from './dataService';



export interface IProps {
  returnAuthorizationId: string;
}

export const FC: React.FC<IProps> = props => {
  const queryTuple = dataService.useQuery(props.returnAuthorizationId);

  return (
    <BaseWidget.FC title="End Customer Information">
      <Grid container>
        <Grid
          item
          xs={6}>
          <LabelledText.FC
            title="First name"
            text={queryTuple.data.returnAuthorization?.firstName} />

          <LabelledText.FC
            title="Email"
            text={queryTuple.data.returnAuthorization?.email} />

          <LabelledText.FC
            title="Mobile"
            text={queryTuple.data.returnAuthorization?.mobile} />

          <LabelledText.FC
            title="Contact Method"
            text={queryTuple.data.returnAuthorization?.contactMethod} />
        </Grid>

        <Grid
          item
          xs={6}>
          <LabelledText.FC
            title="Last Name"
            text={queryTuple.data.returnAuthorization?.lastName} />

          <LabelledText.FC
            title="Email Permission"
            text={queryTuple.data.returnAuthorization?.emailPermission} />

          <LabelledText.FC
            title="SMS Permission"
            text={queryTuple.data.returnAuthorization?.smsPermission} />
        </Grid>
      </Grid>
    </BaseWidget.FC>
  );
};
